export default __webpack_public_path__ + "static/reward-1-524afc4f732f032c64e47c86eced8fac.png";